export const defaultUser = {
  email: "demo@email.com",
  password: "demo@email.com",
  id: "470f8bfe-9105-4d86-bf82-f456cfc803fe",
};
